module.exports =
  accountingReports:
    enqueue: '/netsuite/accountingReports/enqueue'
    base: '/netsuite/accountingReports'
  wms:
    order:
      submit: '/netsuite/wms/order/submit'
      fulfill: '/netsuite/wms/order/fulfill'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/netsuite.coffee